module.exports = __webpack_public_path__ + "img/empty-address.f8f90745.svg";